import useSWR from "swr";
import axios from "axios";

function useUsersCompany({ shouldFetch = true, userId }) {
  return useSWR(shouldFetch ? [`${process.env.REACT_APP_API_URL}/users/${userId}/company`] : null,
    async ([url]) => {
      const params = new URLSearchParams();
      const { data: company } = await axios.get(`${url}?${params.toString()}`);

      return { company };
    });
}

export default useUsersCompany;
